<template>
  <div class="consultation">
      <div class="contianer" v-if="hasMask">
          <div class="waiting-cover">
              <div class="waiting">
                  {{ userInfo.inquiryType == 2 ? '等待医生回复' : '正在为您寻找医生' }}
                  <img src="../../assets/gif/loadingycf.gif" alt="" srcset="" />
              </div>
          </div>
      </div>
      <div class="nav-head" v-if="!hasMask && deviceType !== 'alipay'">
          <div class="back">
              <img src="../../assets/image/nav_back.png" @click="goBack" />
          </div>
          <div class="nav-title">{{ navTitle }}</div>
      </div>
      <div class="contianer" v-if="!hasMask" ref="container" :class="deviceType == 'alipay' ? 'no-nav' : ''">
        <template v-if="userInfo.clientID === isRuiZe">
            <div class="nav-tips">医生问诊过程中，请不要离开聊天页面</div>
            <div class="fix-bottom"></div>
        </template>
          <div class="more-message" v-if="!isCompleted" @click="getMessageList">更多消息</div>
          <div class="no-more-message" v-else>暂无更多消息</div>
          <MessageItem :options="item" v-for="(item) in messageList" :key="item.ID"></MessageItem>
          <div class="seat"></div>
      </div>
      <div class="send-wrap row" v-if="step === 1">
          <div class="image-more">
              <img src="../../assets/image/image_more.png" alt="" srcset="" />
              <Upload accept="image/*" @updateImage="sendImage" :choose="true"></Upload>
          </div>
          <div class="send-input row">
              <input type="text" class="flex-1" v-model="inputValue" placeholder="请输入您要咨询的问题" />
          </div>
          <div class="send-button row center" @click="send" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">发送</div>
      </div>
      <!-- <div class="send-end" v-if="step >= 2">咨询已关闭</div> -->
      <div class="end-inq" v-if="step >= 2">
          <div class="close-inquiry">
              <h3>问诊已关闭</h3>
              <span> 如仍需帮助，请再次发起问诊 </span>
          </div>
          <button class="end-button" :class="deviceType == 'alipay' ? 'huafu-btn' : ''" @click="checkThird" type="primary">
              结束问诊
          </button>
      </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import { showNotify, showDialog } from 'vant';
import { getUrlParams } from '../../utils/const'
import MessageItem from '../../components/messageItem/BaseMessageItem.vue'
import TencentCloudChat from '@tencentcloud/chat';
import Upload from '../../components/upload'
import patientReplyMixin from '@/mixins/patientReply'
export default {
  name: 'consultation',
  mixins: [patientReplyMixin],
  components: {
      MessageItem,
      Upload,
  },
  data() {
      return {
          inputValue: '',
          logined: false,
          messageList: [],
          nextReqMessageID: 0,
          isCompleted: false,
          timer: null,
          isRuiZe: process.env.VUE_APP_RUIZE_CLIENT_ID, // 是否是睿择
          refresh: false
      }
  },
  computed: {
      ...mapGetters(['step', 'orderDetail', 'userInfo', 'hasMask', 'imInfo', 'urlParams', 'deviceType', 'endInquiry']),
      navTitle() {
          if (this.orderDetail.sectionName && this.orderDetail.doctorName) {
              return this.orderDetail.sectionName + '  ' + this.orderDetail.doctorName
          } else {
              return '医生问诊'
          }
      },
  },
  mounted() {
      const deviceType = this.deviceType || getUrlParams()['deviceType'] || 'h5'
      window.addEventListener('popstate', (e) => {
          if (deviceType === 'wechat') {
              try {
                  wx.miniProgram.navigateBack({
                      delta: history.length,
                  })
              } catch (error) {
                  console.log('wx.miniProgram not available, using fallback')
                  history.go(-(history.length - 2))
              }
          } else if (deviceType === 'uniapp') {
              window.postMessage(
                  {
                      data: {
                          action: 'popstate',
                      },
                  },
                  '*'
              )
              uni.postMessage({
                  data: {
                      action: 'popstate',
                  },
              })
          } else {
              history.go(-(history.length - 2))
          }
      })
  },
  async created() {
      // this.getImInfo();
      await this.getUrlParams()
      await this.getOrderStatusInfo()
      this.timListener()
      this.login()
  },

  watch: {
      // '$route.path': function (newVal, oldVal) {
      //   if (newVal === '/consultation') {
      //     this.getOrderStatusInfo()
      //   }
      // }
  },
  methods: {
      checkThird() {
          const { bizID, inquiryOrderID } = this.orderDetail
          const deviceType = this.deviceType || getUrlParams()['deviceType'] || 'h5'
          const params = {
              bizID: bizID,
              inquiryID: inquiryOrderID,
              deviceType: deviceType,
              requireType: 'finishInquiry',
          }
          this.$_http.post(this.$_API.H5_INQUIRY_POST_CHECKTHIRD, params).then((res) => {
              console.log('checkThird res', res, 'deviceType', deviceType)
              if (deviceType == 'alipay') {
                  try {
                      my.navigateBack()
                  } catch (error) {
                      console.log('alipay navigateBack failed, using router.back')
                      this.$router.back()
                  }
                  return
              }
              const { url: rawUrl } = res.data
              // 修复：只对非完整 URL 的相对路径加 /，完整 URL（http/https）不处理
              const url = rawUrl && !rawUrl.startsWith('/') && !rawUrl.startsWith('http://') && !rawUrl.startsWith('https://')
                  ? '/' + rawUrl
                  : rawUrl
              console.log('checkThird url', url)
              if (!url) {
                  if (deviceType === 'wechat') {
                      try {
                          wx.miniProgram.navigateBack({ delta: 1 })
                      } catch (error) {
                          console.log('wx.miniProgram not available, using router.back')
                          this.$router.back()
                      }
                  } else {
                      this.$router.back()
                  }
              } else {
                  // 判断是否真的在微信小程序环境中
                  const isInMiniProgram = typeof wx !== 'undefined' && wx.miniProgram && (window.__wxjs_environment === 'miniprogram' || window.navigator.userAgent.toLowerCase().indexOf('miniprogram') > -1)

                  if (deviceType === 'wechat' && isInMiniProgram) {
                      try {
                          wx.miniProgram.navigateTo({
                              url,
                              fail: function () {
                                  wx.miniProgram.reLaunch({ url })
                              }
                          });
                      } catch (error) {
                          console.log('wx.miniProgram navigation failed, using window.location')
                          window.location.href = url
                      }
                  } else if (deviceType === 'uniapp') {
                      try {
                          window.postMessage(
                              {
                                  data: {
                                      action: 'finishOrder',
                                      url,
                                  },
                              },
                              '*'
                          )
                          uni.postMessage({
                              data: {
                                  action: 'finishOrder',
                                  url,
                              },
                          })
                      } catch (error) {
                          console.log('uniapp postMessage failed, using window.location')
                          window.location.href = url
                      }
                  } else {
                      window.location.href = url
                  }
              }
          })
      },
      async getOrderStatusInfo() {
          if (!this.urlParams.orderID) {
              return false
          }
          let params = {
              orderID: this.urlParams.orderID,
          }
          await this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_ORDER_STATUS, { params }).then((res) => {
              if (res.success) {
                  clearInterval(this.statusTimer)
                  this['user/updateOrderDetail']({
                      ...this.orderDetail,
                      ...res.data,
                      doctorID: res.data.doctorIMID,
                      userSig: res.data.patientUserSig,
                  })
                  if (!this.userInfo.patientInfo) {
                      this['user/updateUserInfo']({ ...this.userInfo, patientInfo: { patientName: res.data.patientName } })
                  }
                  this.toPage()
              }
          })
      },
      toPage() {
          // 问诊状态(0:无 / 1:待派单 / 2:已派单待接诊 / 3:已接诊 / 4:接诊完成 / 5:医生取消 / 6:患者取消 / 7:超时 / ）
          if (this.orderDetail.inquiryStatus === 1) {
              this.$router.replace({
                  path: '/waiting',
                  query: {
                      ...this.urlParams,
                  },
              })
          } else if (this.orderDetail.inquiryStatus > 1 && this.orderDetail.inquiryStatus < 5) {
              if (this.orderDetail.inquiryStatus === 4) {
                  this['global/updateStep'](3)
              } else {
                  this['global/updateStep'](1)
              }
              if (this.orderDetail.inquiryType === 1) {
                  // this.$router.replace({
                  //   path: '/consultation',
                  //   query: {
                  //     ...this.urlParams
                  //   }
                  // })
              } else if (this.orderDetail.inquiryType === 2) {
                  this.$router.replace({
                      path: '/trtcCalling',
                      query: {
                          ...this.urlParams,
                      },
                  })
              } else {
                  this.$router.replace({
                      path: '/videoPage',
                      query: {
                          ...this.urlParams,
                      },
                  })
              }
          } else if (this.orderDetail.inquiryStatus >= 5) {
            showDialog({
                      message: '问诊已取消，请退出后重新发起问诊',
                      confirmButtonText: '知道了',
                      confirmButtonColor: 'var(--order-text, #438BEF)',
                      closeOnClickOverlay: true,
                  })
                  .then(() => {
                      this.$router.replace({
                          path: '/',
                          query: {
                              ...this.urlParams,
                          },
                      })
                  })
          }
      },
      // 快速问诊-获取IM登录信息
      getImInfo() {
          if (!this.orderDetail.bizID) {
              return false
          }
          let params = {
              patientInfoID: '',
              bizID: this.orderDetail.bizID,
              clientID: this.orderDetail.clientID,
              clientAppID: this.orderDetail.clientAppID,
              timestamp: this.orderDetail.timestamp,
              sign: this.orderDetail.sign,
          }
          this.$_http.get(this.$_API.H5_INQUIRY_CENTER_GET_IM_INFO, { params }).then((res) => {
              if (res.success && res.data.orderStatus < 1) {
              }
          })
      },
      // getMessage
      getMessageList() {
          if (this.isCompleted) {
              return false
          }
          // let params = { conversationID: 'C2C' + this.orderDetail.doctorID, count: 15 }
          let params = { conversationID: 'C2C' + this.orderDetail.doctorID, count: 15 }
          let _that = this
          if (this.nextReqMessageID !== 0) {
              params.nextReqMessageID = this.nextReqMessageID
          }
          // 打开某个会话时，第一次拉取消息列表
          let promise = this.tim.getMessageList(params)
          promise.then(function (imResponse) {
              const messageList = imResponse.data.messageList // 消息列表。
              // 部分情况下IM消息不刷新，需要重新拉取消息列表
              if (messageList.length === 0 && !this.refresh) {
                this.refresh = true
                _that.getMessageList()
                return false
              }
              const nextReqMessageID = imResponse.data.nextReqMessageID // 用于续拉，分页续拉时需传入该字段。
              const isCompleted = imResponse.data.isCompleted // 表示是否已经拉完所有消息。
              for (let i = messageList.length - 1; i >= 0; i--) {
                  if (typeof messageList[i].payload.data === 'string' && messageList[i].type === 'TIMCustomElem') {
                      let data = JSON.parse(messageList[i].payload.data)
                      console.log(data)
                      if (data.customType === 'card') {
                          if (data.childType === 'rpImg') {
                              let FileMessage = {
                                  progress: 100,
                                  from: _that.orderDetail.orderPatientID + '1',
                                  type: 'TIMImageElem',
                                  src: data.data.rpImgUrl,
                                  payload: {
                                      data: 'imageMessage',
                                  },
                              }
                              _that['global/updateStep'](2)
                              messageList.splice(i, 1, FileMessage)
                          }
                      } else if (data.customType === 'sys') {
                          if (data.childType === 'doctor_reject') {
                              this['global/updateStep'](2)
                          } else if (data.childType === 'doctor_pass') {
                              this['global/updateStep'](3)
                          }
                      }
                      if (_that.step === 3 || _that.step === 2) {
                          break
                      }
                  }
              }
              if (_that.nextReqMessageID === 0) {
                _that.$nextTick(function () {
                  _that.messageList.unshift(...messageList.slice(0, messageList.length - _that.messageList.length))
                })
              } else {
                  _that.$nextTick(function () {
                      _that.messageList.unshift(...messageList)
                  })
              }
              console.log(_that.messageList, Date.now())
              _that.nextReqMessageID = nextReqMessageID
              _that.isCompleted = isCompleted
              _that.handleScrollBottom()
          })
      },
      // 添加监听消息
      timListener() {
          // 收到新消息
        this.tim.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
        this.tim.on(TencentCloudChat.EVENT.NET_STATE_CHANGE, this.onNetStateChange)
        this.tim.on(TencentCloudChat.EVENT.SDK_READY, this.sdkReady)
        // this.getMessageList()
      },
      // sdk监听初始化成功，tim ready状态
      sdkReady(event) {
          console.log('%csdkReady: true', 'font-size:24px;color:red;')
          this.logined = true
          this.getMessageList()
      },
      onNetStateChange(event) {
        if (event.data.state === 'connected') {
            window.location.reload()
        }
      },
      // 监听收到消息的事件
      onReceiveMessage(event) {
          console.log('=================')
          console.log('event', event)
          // const endTxt = '本次会话已关闭~如有非医学类问题咨询，请联系客服哦~'
          if (event.data[0].payload.description === 'inquiryFinish' && event.data[0].type === 'TIMCustomElem') {
              this['global/updateStep'](2)
          }
          if (typeof event.data[0].payload.data === 'string' && event.data[0].type === 'TIMCustomElem') {
              let data = JSON.parse(event.data[0].payload.data)
              if (data.customType === 'sys') {
                  if (data.childType === 'doctor_reject') {
                      this['global/updateStep'](2)
                  } else if (data.childType === 'doctor_pass') {
                      this['global/updateStep'](3)
                  } else if (data.childType === 'sendDoctorInfo') {
                      this['global/updateDoctorInfo'](data.data)
                  } else if (data.childType === 'rp_order_start') {
                      this['global/updateStep'](1)
                      this['user/updateOrderDetail']({
                          ...this.orderDetail,
                          doctorID: JSON.parse(event.data[0].payload.data).data.doctorID,
                      })
                      this['global/updateMask'](false)
                  }
                  return false
              } else if (data.customType === 'card') {
                  if (data.childType === 'rpImg') {
                      let FileMessage = {
                          progress: 100,
                          from: this.orderDetail.orderPatientID + '1',
                          type: 'TIMImageElem',
                          src: data.data.rpImgUrl,
                          payload: {
                              data: 'imageMessage',
                          },
                      }
                      this['global/updateStep'](2)
                      this.messageList.push(FileMessage)
                      this.handleScrollBottom()
                      return false
                  }
              }
          }
          this.messageList.push(event.data[0])
          this.handleScrollBottom()
      },
      // 通过接口获取计算签名
      getUserSig() {
          let params = { userId: this.orderDetail.orderPatientID || this.userInfo.orderPatientID }
          this.$_http.get(this.$_API.INITIAL_GET_USER_SIG, { params }).then((res) => {
              this.login(res.data.userSig)
          })
      },
      // 登录tim
      login() {
          let userSig = this.imInfo.userSig || this.orderDetail.userSig
          if (this.logined) {
              return false
          }
          console.log('%c登录信息:', 'font-size:24px;color:red;')
          console.log(this.imInfo.patientImID + '/' + userSig)
          this.tim.login({ userID: this.imInfo.patientImID || this.orderDetail.patientIMID, userSig }).then((res) => {
              this.logined = true
              console.log('TIM登录成功')
              this.handleScrollBottom()
          })
      },
      send() {
          this.sendClick()
      },
      // 发送消息
      sendClick() {
          let _that = this
          if (!this.logined) {
              showNotify({
                  type: 'warning',
                  message: '请先登录',
                  duration: 1000,
              })
              return false
          }
          if (this.inputValue === '') {
              showNotify({
                  type: 'warning',
                  message: '请输入内容',
                  duration: 1000,
              })
              return false
          }
          let message = this.tim.createTextMessage({
              to: this.orderDetail.doctorID,
              conversationType: TencentCloudChat.TYPES.CONV_C2C,
              payload: {
                  text: this.inputValue,
              },
          })
          let promise = this.tim.sendMessage(message)
          promise
              .then(function (imResponse) {
                  // 发送成功
                  _that.reportPatientReply(0)
                  _that.messageList.push({
                      from: _that.orderDetail.patientIMID || _that.imInfo.patientImID || _that.orderDetail.orderPatientID,
                      type: 'TIMTextElem',
                      payload: {
                          text: _that.inputValue,
                      },
                  })
                  _that.inputValue = ''
                  _that.handleScrollBottom()
              })
              .catch(function (imError) {
                  // 发送失败
                  console.warn('sendMessage error:', imError)
                  showNotify({
                      type: 'warning',
                      message: '发送失败',
                      duration: 1000,
                  })
                  return false
              })
      },
      // 发送消息、获取消息向下滚动
      handleScrollBottom() {
          setTimeout(() => {
              let dom = this.$refs.container
              if (!dom || dom.scrollHeight === 0) {
                  return false
              }
              // dom.scrollTop = dom.scrollHeight - dom.clientHeight
              dom.scrollTop = dom.scrollHeight
          }, 100)
      },
      // 选取发送照片
      async sendImage({ files, id, type }) {
          console.log(files)
          let _that = this
          let FileMessage = null
          let message = null
          if (type === 'image') {
              const imgUrl = await _that.upload(files[0])
              const ImgData = {
                  customType: 'image',
                  childType: 'sendImage',
                  data: {
                      url: imgUrl,
                  },
              }
              const payload = {
                  data: JSON.stringify(ImgData),
                  description: '发送图片',
                  extension: 'ycf',
              }
              message = await _that.tim.createCustomMessage({
                  from: _that.orderDetail.orderPatientID || _that.imInfo.patientImID || _that.orderDetail.patientIMID,
                  to: _that.orderDetail.doctorID,
                  conversationType: TencentCloudChat.TYPES.CONV_C2C,
                  payload,
              })
              _that.messageList.push({
                  from: _that.orderDetail.orderPatientID || _that.imInfo.patientImID || _that.orderDetail.patientIMID,
                  type: 'TIMCustomElem',
                  payload,
              })
          } else if (type === 'video') {
              let blob = new Blob(files[0])
              FileMessage = {
                  progress: 0,
                  from: _that.orderDetail.orderPatientID,
                  type: 'TIMVideoFileElem',
                  src: window.URL.createObjectURL(blob),
                  payload: {
                      data: 'videoMessage',
                  },
              }
              message = _that.tim.createVideoMessage({
                  to: this.orderDetail.doctorID,
                  conversationType: TencentCloudChat.TYPES.CONV_C2C,
                  payload: {
                      file: files[0],
                  },
                  onProgress: function (event) {
                      FileMessage.progress = event * 100
                  },
              })
              _that.messageList.push(FileMessage)
              _that.popupDialog = false
              _that.$nextTick(function () {
                  _that.handleScrollBottom()
              })
          }
          // 2. 发送消息
          let promise = _that.tim.sendMessage(message)
          promise
              .then(function (imResponse) {
                  // 发送成功
                  if (type === 'image') {
                      _that.reportPatientReply(1)
                  }
                  _that.$nextTick(function () {
                      _that.handleScrollBottom()
                  })
              })
              .catch(function (imError) {
                  // 发送失败
                  console.warn('sendMessage error:', imError)
                  showNotify({
                      type: 'warning',
                      message: '发送失败',
                      duration: 1000,
                  })
              })
      },
      async upload(file) {
          let formData = new FormData()
          formData.append('systemCode', 'TMC')
          formData.append('belongCode', 'CONTENT')
          formData.append('belongID', this.userInfo.orderID || this.orderDetail.inquiryOrderID)
          formData.append('file', file)
          let remoteAddress = ''
          await this.$_http
              .post(this.$_API.TMC_POST_UPLOAD_FILE, formData, {
                  headers: {
                      'Content-Type': 'multipart/form-data',
                  },
              })
              .then((res) => {
                  if (res.data) {
                      remoteAddress = res.data.remoteAddress
                  }
              })
          return remoteAddress
      },
      goBack() {
          // this.$router.back()
          const deviceType = this.deviceType || getUrlParams()['deviceType'] || 'h5'
          showDialog({
                  title: '退出提示',
                  message: '您确定要离开对话吗？',
                  confirmButtonText: '确定',
                  confirmButtonColor: 'var(--order-text, #438BEF)',
                  showCancelButton: true,
                  cancelButtonText: '取消',
                  cancelButtonColor: 'var(--order-text, #438BEF)',
                  closeOnClickOverlay: true,
              })
              .then(() => {
                  if (deviceType === 'wechat') {
                      try {
                          wx.miniProgram.navigateBack({
                              delta: history.length,
                          })
                      } catch (error) {
                          console.log('wx.miniProgram not available, using router.back')
                          this.$router.back()
                      }
                  } else if (deviceType === 'uniapp') {
                      try {
                          window.postMessage(
                              {
                                  data: {
                                      action: 'popstate',
                                  },
                              },
                              '*'
                          )
                          uni.postMessage({
                              data: {
                                  action: 'popstate',
                              },
                          })
                      } catch (error) {
                          console.log('uniapp postMessage failed, using router.back')
                          this.$router.back()
                      }
                  } else if (deviceType == 'alipay') {
                      try {
                          my.navigateBack()
                      } catch (error) {
                          console.log('alipay navigateBack failed, using router.back')
                          this.$router.back()
                      }
                  } else {
                      this.$router.back()
                      // history.go(-(history.length - 2));
                  }
              })
      },
      getUrlParams() {
          if (this.$route.name === 'rpViewer') return
          let obj = this.$route.query
          if (!obj['orderID'] || !obj['token']) {
            showDialog({
                  message: '参数缺失，请重新进入',
                  confirmButtonText: '确定',
                  confirmButtonColor: 'var(--order-text, #438BEF)',
                  closeOnClickOverlay: true,
              })
          }
          this['global/updateUrlParams'](obj)
      },
      ...mapMutations([
          'global/updateStep',
          'global/updateDoctorInfo',
          'user/updateOrderDetail',
          'global/updateMask',
          'global/updateUrlParams',
          'user/updateUserInfo',
      ]),
  },
  unmounted() {
      if (this.timer) {
          clearInterval(this.timer)
      }
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/common.scss';

.consultation {
  height: calc(100vh - 2rem);
}

.seat {
  height: 15px;
  width: 100%;
}

.nav-head {
  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 44px;
  background: white;
  display: flex;
  align-items: center;

  .back {
    margin-top: 8px;
    margin-left: 8px;

    img {
      width: 24px;
    }
  }

  .nav-title {
    font-size: 18px;
    display: flex;
    justify-content: center;
    width: calc(100% - 36px);
    margin-right: 36px;
  }
}

@media  (max-height: 610px) {
  .nav-head {
    position: fixed;
    z-index: 999;
    left: 0;
    top: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    background: white;
    display: flex;
    align-items: center;

    .back {
      margin-top: 5px;
      margin-left: 5px;

      img {
        width: 18px;
      }
    }

    .nav-title {
      font-size: 12px;
      display: flex;
      justify-content: center;
      width: calc(100% - 36px);
      margin-right: 36px;
    }
  }
}


.contianer {
  height: calc(100vh - 42px);
  overflow: scroll;
  margin-top: 44px;
  position: relative;
  z-index: 888;
  padding-bottom: 60px;
  background: #f5f5f5;
}
.nav-tips{
  background: #FEEFD0;
  padding: 10px 16px;
  font-size: 12px;
  text-align: center;
  color: #F6A70A;
  position: fixed;
  width: 100%;
}
.fix-bottom{
    height: 41px;
}
.message-item {
  margin-top: 16px;
}

.more-message,
.no-more-message {
  color: var(--order-text, #2887e8);
  font-size: 13px;
  padding: 15px 10px 0;
  text-align: center;
}
@media (max-height: 610px) {
  .contianer {
    margin-top: 20px;
    padding-bottom: 5px;
  }
  .more-message
  .no-more-message {

    font-size: 12px;

    text-align: center;
  }
}

.waiting {
  background: var(--order-soft, #def3ea);
  color: var(--order-text, #0a6f41);
  padding: 10px 16px;
  font-size: 14px;
  display: inherit;
  border-radius: 8px;
  margin-top: 24px;
  align-items: center;
}

.waiting > img {
  height: 24px;
  width: 24px;
}

.waiting-cover {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.send-end {
  font-size: 15px;
  background-color: #ffffff;
  text-align: center;
  padding: 12px 0;
}

.send-wrap {
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  background: #fff;
  padding: 8px 16px;
  box-sizing: border-box;

  .image-more {
      position: relative;

      img {
          display: flex;
          height: 24px;
          width: 24px;
      }

      .upload-input-cover {
          opacity: 0;
          position: absolute;
          // height: 24px;
          // width: 24px;
          // top: 14px;
          // left: 16px;
          top: 0;
          left: 0;
      }
  }



  .send-input {
      width: calc(100vw - 140px);;
      height: 36px;
      overflow: hidden;
      margin: 0 12px;
      padding: 2px 6px;
      box-sizing: border-box;

      input {
          font-size: 14px;
          border-radius: 19.5px;
          padding: 0 16px;
          background: #eeeeee;
      }
  }

  .send-button {
      width: 60px;
      height: 36px;
      border-radius: 24px;
      opacity: 1;
      font-size: 14px;
      color: var(--order-on-primary, #fff);
      // background: linear-gradient(90deg, rgba(134, 174, 252, 1) 0%, rgba(36, 90, 234, 1) 100%);
      background: var(--order-primary, var(--primary-color));
  }
}

.end-button {
  font-size: 14px;
  color: var(--order-on-primary, #fff);
  border: none;
  background-color:  var(--order-primary, var(--primary-color));
  padding: 5px 20px;
  margin: 18px 0;
  border-radius: 4px;
}

.end-inq {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 999;
  background: white;
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
}

.close-inquiry {
  h3 {
      font-size: 14px;
      position: absolute;
      top: 12px;
  }

  span {
      font-size: 12px;
      color: #666;
      position: absolute;
      top: 36px;
  }
}

.no-nav {
  height: 100vh !important;
  margin: 0 !important;
}

@media  (max-height: 610px) {
  .send-wrap{
    padding: 2px 3px;
    .send-button {
      height: 25px;
    }
    .send-input{
      height: 30px;
    }
  }

}
</style>
